import React, { useEffect, useState } from 'react';
import api from '../services/api';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { useNavigate } from 'react-router-dom';
import { Accordion, AccordionBody, AccordionHeader, AccordionItem, Card, CardBody, CardTitle } from 'reactstrap';
import { toast } from 'react-toastify';
import { LiaAngleDoubleUpSolid } from 'react-icons/lia';
import '../styles/floatingForm.css'
import gsap from 'gsap';
import moment from 'moment';

const ShowApprovePackage = ({setShowUpdatePackage, containerUpdateRef, id,cardId
,setCardId
,fetchCards
,setShowModal, cardById}) => {
      const [categories, setCategories] = useState([]);
      const [vendors, setVendors] = useState([]);
      const [open, setOpen] = useState('1');
    
      useEffect(() => {
        const fetchCategories = async () => {
          const response = await api.get('/page/get-all');
          setCategories(response.data.data);
        };
    
        const fetchVendors = async () => {
          const response = await api.get('/vendor/get-all');
          setVendors(response.data.data);
        };
    
    
    
        fetchCategories();
        fetchVendors();
      }, [cardId]);
    
      const validateImageDimensions = (file, maxWidth, maxHeight) => {
        return new Promise((resolve, reject) => {
          const image = new Image();
          image.onload = () => {
            if (image.width <= maxWidth && image.height <= maxHeight) {
              resolve(true);
            } else {
              resolve(false);
            }
          };
          image.onerror = () => {
            reject(new Error('Invalid image file.'))
          };
          image.src = URL.createObjectURL(file);
        });
      };
    
      const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            // Update existing category
            const response = await api.post(`/product/updateapprove/${cardId}`, {
            is_approved: 1,
            });
            if (response.data.status === "success") {
            toast.success(`Package Approved successfully!`);
            } else {
            toast.error('Failed to update category');
            }
        
            setCardId('');
            setShowModal(false);
            fetchCards(); 
        } catch (error) {
            console.error('Error saving category:', error);
            toast.error('Error saving category');
        }
    };
    
      const handleCancel = () => {
        
                setShowModal(false);
      };
    
      const toggle = (id) => {
        if (open === id) {
          setOpen("0");
        } else {
          setOpen(id);
        }
      };

  return (
    <div className='floating-form-container' ref={containerUpdateRef} >
      <div className="heading">
        <h2>Package Details</h2>
      </div>

        <form onSubmit={handleSubmit}>
            <div className="form-container">

                <div className="section-1">

                    <div className="input-container-floating-form wid-30">
                        <label >Package Name</label>
                         <input type="text" readonly class="form-control" value={cardById?.packagename} />
                      
                    </div>

                    <div className="input-container-floating-form wid-30">
                        <label >Service Provider</label>
                         <input type="text" readonly class="form-control" value={vendors.filter(el => el.id === cardById.vendor_id)[0]?.name} />
                      
                    </div>

                    <div className="input-container-floating-form wid-30">
                        <label >Category</label>
                        <input type="text" readonly class="form-control" value={categories.filter(el => el.id === cardById.category_id)[0]?.name} />
                      
                    </div>

                    <div className="input-container-floating-form wid-30">
                        <label>City *</label>
                        <input type="text" class="form-control" readonly  value={cardById?.city} />
                      
                    </div>

                    <div className="input-container-floating-form wid-30">
                        <label >Duration</label>
                        <input type="text" class="form-control" readonly  value={cardById?.duration} />
                    </div>

                    <div className="input-container-floating-form wid-30">
                        <label >Price</label>
                        <input type="text" class="form-control" readonly  value={cardById?.price} />
                    </div>
                    
                </div>

                <hr className='form-rule' />

                <div className="section-1">

                  <div className="input-container-floating-form wid-100">
                        <label >Highlights</label>
                        
                        <ReactQuill className={`react-quill`} readOnly value={cardById?.highlights}  />
                    </div>

                    <div className="input-container-floating-form wid-100">
                        <label >What's included</label>
                        
                        <ReactQuill className={`react-quill`} readOnly value={cardById?.included}  />
                    </div>

                    <div className="input-container-floating-form wid-100">
                        <label >What's Not Included</label>
                        
                        <ReactQuill className={`react-quill`} readOnly value={cardById?.not_included}  />
                    </div>

                    <div className="input-container-floating-form wid-100">
                        <label >Requirement</label>
                        
                        <ReactQuill className={`react-quill`} readOnly value={cardById?.requirement}  />
                    </div>

                    <div className="input-container-floating-form wid-100">
                        <label >Booking Policy</label>
                        
                        <ReactQuill className={`react-quill`} readOnly value={cardById?.booking_policy}  />
                    </div>

                    <div className="input-container-floating-form wid-100">
                        <label >Cancellation Policy</label>
                        
                        <ReactQuill className={`react-quill`} readOnly value={cardById?.cancellation_policy}  />
                    </div>

                </div>

                <hr className='form-rule' />
                

                <div className="section-1">

                    <div className="input-container-floating-form wid-50">
                        <label >Room Sharing</label>
                        <input type="text" class="form-control" readonly  value={cardById?.room_sharing} />
                    </div>

                    <div className="input-container-floating-form wid-100">
                        <label >Room Details</label>
                        
                        <ReactQuill className={`react-quill`} readOnly value={cardById?.room_details}  />
                    </div>

                    <div className="input-container-floating-form wid-50">
                        <label >Departure Point</label>
                        <input type="text" class="form-control" readonly  value={cardById?.departure_point} />
                      
                    </div>

                    <div className="input-container-floating-form wid-50">
                        <label >Departure Date</label>
                        <input type="date" class="form-control" readonly  value={moment(cardById?.departure_date).format('YYYY-MM-DD')} />
                    </div>

                    <div className="input-container-floating-form wid-100">
                        <label >Departure Details</label>
                        
                        <ReactQuill className={`react-quill`} readOnly value={cardById?.departure_details}  />
                    </div>

                    <div className="input-container-floating-form wid-50">
                        <label >Arrival Point</label>
                        <input type="text" class="form-control" readonly  value={cardById?.arrival_point} />
                      
                    </div>

                    <div className="input-container-floating-form wid-50">
                        <label >Arrival Date</label>
                        <input type="date" class="form-control" readonly  value={moment(cardById?.arrival_date).format('YYYY-MM-DD')} />
                    </div>

                    <div className="input-container-floating-form wid-100">
                        <label >Arrival Details</label>
                        
                        <ReactQuill className={`react-quill`} readOnly value={cardById?.arrival_details}  />
                    </div>

                    <div className="input-container-floating-form wid-50">
                        <label >Number of Days</label>
                        <input type="text" class="form-control" readonly  value={cardById?.number_of_days} />
                      
                    </div>

                    <div className="input-container-floating-form wid-100">
                        <label >Days Details</label>
                        
                        <ReactQuill className={`react-quill`} readOnly value={cardById?.days_details}  />
                    </div>

                    <div className="input-container-floating-form wid-50">
                        <label >Airline </label>
                        <input type="text" class="form-control" readonly  value={cardById?.airline} />
                      
                    </div>

                    <div className="input-container-floating-form wid-100">
                        <label >Airline Details</label>
                        
                        <ReactQuill className={`react-quill`} readOnly value={cardById?.airline_details}  />
                    </div>

                    <div className="input-container-floating-form wid-50">
                        <label >Visa</label>
                        <input type="text" class="form-control" readonly  value={cardById?.visa} />
                      
                    </div>

                    <div className="input-container-floating-form wid-100">
                        <label >Visa Details</label>
                        
                        <ReactQuill className={`react-quill`} readOnly value={cardById?.visa_details}  />
                    </div>

                    <div className="input-container-floating-form wid-50">
                        <label >Transfer</label>
                        <input type="text" class="form-control" readonly  value={cardById?.transfer} />
                      
                    </div>

                    <div className="input-container-floating-form wid-100">
                        <label >Transfer Details</label>
                        
                        <ReactQuill className={`react-quill`} readOnly value={cardById?.transfer_details}  />
                    </div>

                    <div className="input-container-floating-form wid-50">
                        <label >Food</label>
                        <input type="text" class="form-control" readonly  value={cardById?.food} />
                    </div>

                    <div className="input-container-floating-form wid-100">
                        <label >Food Details</label>
                        
                        <ReactQuill className={`react-quill`} readOnly value={cardById?.food_details}  />
                    </div>

                    <div className="input-container-floating-form wid-50">
                        <label >Sightseeing *</label>
                        <input type="text" class="form-control" readonly  value={cardById?.sightseeing} />
                      
                    </div>

                    <div className="input-container-floating-form wid-100">
                        <label >Sightseeing Details</label>
                        
                        <ReactQuill className={`react-quill`} readOnly value={cardById?.sightseeing_details}  />
                    </div>

                    <div className="input-container-floating-form wid-50">
                        <label >Distance from Kaba</label>
                        <input type="text" class="form-control" readonly  value={cardById?.distance_from_kaba} />
                      
                    </div>

                    <div className="input-container-floating-form wid-100">
                        <label >Kaba Details</label>
                        
                        <ReactQuill className={`react-quill`} readOnly value={cardById?.kaba_details}  />
                    </div>

                    <div className="input-container-floating-form wid-50">
                        <label >Distance from Rawda</label>
                        <input type="text" class="form-control" readonly  value={cardById?.distance_from_rawda} />
                    </div>

                    <div className="input-container-floating-form wid-100">
                        <label >Rawda Details</label>
                        
                        <ReactQuill className={`react-quill`} readOnly value={cardById?.rawda_details}  />
                    </div>

                    

                </div>

                <div className="section-1">

                    <h2 className='wid-100'>Upload Image</h2>

                    <div className="input-container-floating-form wid-50">
                        <label>Package Image</label>
                        
                        <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}${cardById?.image_path}`} alt="Existing" style={{ maxWidth: '100px', maxHeight: '100px' }} />

                    </div>
                    <div className="input-container-floating-form wid-50">
                        <label>Banner Image</label>
                        
                        <img src={`${process.env.REACT_APP_IMAGE_BASE_URL}${cardById?.banner_image_path}`} alt="Existing" style={{ maxWidth: '100px', maxHeight: '100px' }} />

                    </div>
                </div>

            </div>

            <div className="form-btn-container">

                <button type='submit'>Approve</button>
                <button type='reset' onClick={handleCancel}>Cancel</button>

            </div>


        </form>

    </div>
  );
};

export default ShowApprovePackage;
